(function () {
  'use strict';

  class ProductCardSaleBadge extends HTMLElement {
    static parseMoney(value) {
      var normalized = String(value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/[^\d,.-]/g, '');

      if (!normalized || !/\d/.test(normalized)) return null;

      var lastDot = normalized.lastIndexOf('.');
      var lastComma = normalized.lastIndexOf(',');
      var separatorIndex = Math.max(lastDot, lastComma);
      var decimalLength = separatorIndex >= 0 ? normalized.length - separatorIndex - 1 : 0;
      var hasDecimalSeparator = decimalLength > 0 && decimalLength <= 2;

      if (hasDecimalSeparator) {
        normalized = normalized.slice(0, separatorIndex).replace(/[.,]/g, '')
          + '.'
          + normalized.slice(separatorIndex + 1).replace(/[.,]/g, '');
      } else {
        normalized = normalized.replace(/[.,]/g, '');
      }

      var amount = Number(normalized);
      return Number.isFinite(amount) ? amount : null;
    }

    static discountPercent(currentPrice, compareAtPrice) {
      if (!Number.isFinite(currentPrice) || !Number.isFinite(compareAtPrice)) return 0;
      if (currentPrice < 0 || compareAtPrice <= 0 || currentPrice >= compareAtPrice) return 0;

      return Math.max(1, Math.min(100, Math.round((1 - currentPrice / compareAtPrice) * 100)));
    }

    connectedCallback() {
      this.card = this.closest('product-card');
      if (!this.card) return;

      this.nativeSale = this.dataset.nativeSale === 'true';
      this.saleLabel = this.dataset.saleLabel || 'Sale';
      this.percentLabel = this.dataset.percentLabel || '__PERCENT__% off';
      this.updateQueued = false;

      this.observer = new MutationObserver((records) => {
        if (records.some((record) => this.mutationTouchesPrice(record))) {
          this.queueUpdate();
        }
      });
      this.observer.observe(this.card, {
        attributes: true,
        attributeFilter: ['class'],
        characterData: true,
        childList: true,
        subtree: true
      });

      this.queueUpdate();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    mutationTouchesPrice(record) {
      var target = record.target.nodeType === Node.ELEMENT_NODE
        ? record.target
        : record.target.parentElement;

      if (target && target.closest && target.closest('.price')) return true;

      return Array.from(record.addedNodes || []).some((node) => {
        return node.nodeType === Node.ELEMENT_NODE
          && (node.matches('.price') || node.querySelector('.price'));
      });
    }

    queueUpdate() {
      if (this.updateQueued) return;
      this.updateQueued = true;

      var schedule = window.requestAnimationFrame || function (callback) { return setTimeout(callback, 0); };
      schedule(() => {
        this.updateQueued = false;
        this.updateBadge();
      });
    }

    updateBadge() {
      var prices = Array.from(this.card.querySelectorAll('.price'));
      var percent = 0;

      prices.some((price) => {
        var current = price.querySelector('.price__current');
        var compareAt = price.querySelector('.price__was');
        if (!current || !compareAt) return false;

        percent = ProductCardSaleBadge.discountPercent(
          ProductCardSaleBadge.parseMoney(current.textContent),
          ProductCardSaleBadge.parseMoney(compareAt.textContent)
        );
        return percent > 0;
      });

      if (percent > 0) {
        this.textContent = this.percentLabel.replace('__PERCENT__', percent);
        this.hidden = false;
        this.card.classList.add('card--on-sale');
        return;
      }

      this.textContent = this.saleLabel;
      this.hidden = !this.nativeSale;
      this.card.classList.toggle('card--on-sale', this.nativeSale);
    }
  }

  if (!customElements.get('product-card-sale-badge')) {
    customElements.define('product-card-sale-badge', ProductCardSaleBadge);
  }
})();
